// extracted by mini-css-extract-plugin
module.exports = {"title":"footerSocial_title__1E5zD","socialContainer":"footerSocial_socialContainer__3D2LT"};
    if(module.hot) {
      // 1746134881845
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  